export interface LsiErrorInfo {
    source: string;
    message: string;
    status?: number;
    detail?: any;
}

export interface LsiEnvelope {
    ok: boolean;
    data?: any;
    error?: LsiErrorInfo;
}

// Unwraps the standard Lambda response envelope { ok, data | error }.
// Returns the inner data on success; throws a classified Error on failure
// (the [source] prefix tells whether a retry can help: validation = fix the
// request, platform = inspect detail, internal = retry may help).
// Pre-envelope payloads (no `ok` field) pass through unchanged so the
// frontend can deploy before or after the Lambdas.
export const unwrapLsiEnvelope = (payload: any): any => {
    if (payload && payload.ok === true) {
        return payload.data;
    }
    if (payload && payload.ok === false) {
        const errorInfo: LsiErrorInfo = payload.error || {};
        if (errorInfo.detail) {
            console.error(JSON.stringify(errorInfo.detail));
        }
        const error = new Error(
            `[${errorInfo.source || 'unknown'}] ${
                errorInfo.message || 'request failed'
            }`,
        );
        // Carry the upstream HTTP status onto the thrown error. A marketplace
        // 429 arrives INSIDE this envelope (the delegate returns HTTP 200), so
        // without this, isThrottleError sees an error with no status and a
        // platform rate limit is treated as a hard failure instead of being
        // retried with backoff. Our own gateway's 429 takes the other path —
        // a bare AjaxError that never reaches this function.
        (error as Error & { status?: number }).status = errorInfo.status;
        throw error;
    }
    return payload;
};
